var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Prewiew',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Avatar ")]},proxy:true},{key:"content",fn:function(){return [_c('Avatar',{attrs:{"url":_vm.url,"size":_vm.size}})]},proxy:true},{key:"desc",fn:function(){return [_vm._v(" "+_vm._s(_vm.desc)+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }